import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/HorizontalNavigation/HorizontalNavigation.js'
import WebComponent from '../../WebComponent.js'
import Navigation from './Navigation.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'
import MonitoringService from '../Monitoring/MonitoringService'

export default class HorizontalNavigation extends WebComponent {

  constructor() {
    super()
    this.isUserAllowed = false
  }

  get translationFile() {
    return './views/Navigation/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.navigationListener = _ => {
      this.reload()
    }
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)

    if (window.isAnonymousAccess) {
      this.render()
      return
    }

    Promise.resolve(
      new MonitoringService().isUserAllowed()
    )
      .then(isUserAllowed => {
        this.isUserAllowed = isUserAllowed
        this.render()
      })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  getTemplate() {
    if (window.isAnonymousAccess) {
      return html``
    }

    const authorizationFilter = new AuthorizationFilter()
    const items = [
      {text: this.i18n.translate('navigation.dashboard'), url: 'Dashboard', active: true},
      {text: this.i18n.translate('navigation.monitoring'), url: 'Monitoring'},
      {text: this.i18n.translate('navigation.administration'), url: 'Administration', suburls: ['AdministrationEdit']}
    ]
      .filter(i => authorizationFilter.viewAllowed(i.url))
      .filter(i => i.url !== 'Monitoring' || this.isUserAllowed)

    return html`
      <isceco-horizontal-navigation .items="${items}">
      </isceco-horizontal-navigation>
    `
  }
}
customElements.define('eform-frontend-horizontal-navigation', HorizontalNavigation)
